import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  BadgeCheck,
  BarChart3,
  Image as ImageIcon,
  LayoutDashboard,
  Repeat,
  Tag,
  Users,
  Wrench,
} from 'lucide-react';
import { MEMBERSHIP_TABS, msSubNavClass, msSubNavItem } from './membershipUi';

const TAB_ICONS: Record<string, React.ReactNode> = {
  dashboard: <LayoutDashboard className="h-5 w-5" />,
  plans: <Tag className="h-5 w-5" />,
  memberships: <Users className="h-5 w-5" />,
  transfers: <Repeat className="h-5 w-5" />,
  reports: <BarChart3 className="h-5 w-5" />,
  settings: <ImageIcon className="h-5 w-5" />,
  tools: <Wrench className="h-5 w-5" />,
};

const MembershipSidebar: React.FC = () => {
  const location = useLocation();

  return (
    <aside className={msSubNavClass} aria-label="Membership modules">
      <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-600/15 text-emerald-600">
        <BadgeCheck className="h-5 w-5" />
      </div>
      {MEMBERSHIP_TABS.map((tab) => {
        const active =
          tab.id === 'dashboard'
            ? location.pathname === tab.path || location.pathname === `${tab.path}/`
            : location.pathname.startsWith(tab.path);
        return (
          <NavLink key={tab.id} to={tab.path} title={tab.label} className={msSubNavItem(active)}>
            {TAB_ICONS[tab.id]}
          </NavLink>
        );
      })}
    </aside>
  );
};

export default MembershipSidebar;
